import { scrollToElement } from 'telia-front-react';
import { resolveThemePackagePrices } from './TvComparisonPriceUtil';
const DEFAULT_VISIBLE_THEMES_COUNT = 10;
export const createThemePackagesGroup = ({ themes, translate, isAllShown, filterActions, shownItemsCount }) => {
    const visibleThemesCount = shownItemsCount || DEFAULT_VISIBLE_THEMES_COUNT;
    const shownThemes = isAllShown ? themes : themes.slice(0, visibleThemesCount);
    return {
        label: `${translate('tvcomparison.themepackages.label')}`,
        count: themes.length,
        packets: shownThemes,
        viewAllButton: themes.length > visibleThemesCount && {
            text: isAllShown ? translate('tvcomparison.showLess.label') : `${translate('tvcomparison.showAll.label')} (+${themes.length - visibleThemesCount})`,
            size: 'small',
            variant: 'secondary',
            onClick: async (event) => {
                await filterActions.toggleAllThemesShown(event);
                isAllShown && scrollToElement(shownThemes[0].id);
            }
        }
    };
};
export const mapThemePackages = (themePackages, channelsMap, commonProps) => {
    if (!(themePackages === null || themePackages === void 0 ? void 0 : themePackages.length)) {
        return {};
    }
    const themesMap = {};
    themePackages.forEach((themePackage, index) => {
        const identifier = `${index}-${themePackage.productOfferingCode}-${commonProps.identifier}`;
        themesMap[themePackage.productSpecId] = {
            icon: `#${commonProps.getIcon(themePackage.productOfferingCode)}`,
            title: themePackage.title,
            id: `${themePackage.productOfferingCode}-${commonProps.identifier}`,
            description: themePackage.description,
            channels: mapThemePackageChannels(themePackage, channelsMap, identifier),
            packetPrices: resolveThemePackagePrices(themePackage.prices, commonProps)
        };
    });
    return themesMap;
};
const mapThemePackageChannels = (themePackage, channelsMap, identifier) => {
    var _a, _b;
    if (!((_a = themePackage.channelIds) === null || _a === void 0 ? void 0 : _a.length)) {
        return [];
    }
    return (_b = themePackage.channelIds) === null || _b === void 0 ? void 0 : _b.filter((id) => channelsMap[id]).map((id, index) => mapThemePackageChannel(channelsMap[id], `${index}-${identifier}`));
};
const mapThemePackageChannel = (channel, identifier) => {
    const srcset = (channel === null || channel === void 0 ? void 0 : channel.images) && Object.values(channel.images).join(', ');
    return {
        id: `theme-channel-${channel.id}-${identifier}`,
        title: channel.title,
        description: channel.description,
        image: {
            role: 'presentation',
            srcset
        },
        packetPrices: []
    };
};
